import { render } from "./HeroComponent.vue?vue&type=template&id=28957ab1"
import script from "./HeroComponent.vue?vue&type=script&lang=js"
export * from "./HeroComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\hhsiao\\Downloads\\Mamba\\cloud-business\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__